const { BRAND_NAME } = require('../../constants/env');

const LOWER_CASED_BRAND_NAME = BRAND_NAME.toLowerCase();

const isFlagler = BRAND_NAME === 'FLAGLER';

const isHealthfully = BRAND_NAME === 'HEALTHFULLY';

module.exports = {
  isFlagler,
  isHealthfully,
  LOWER_CASED_BRAND_NAME,
};



// WEBPACK FOOTER //
// ./src/whitelabel/helpers/contants.js